/**
 * Copyright utility functions for QuailGame Footy
 */

/**
 * Get the current year for copyright notices
 * @returns {number} Current year
 */
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

/**
 * Generate the full copyright text with dynamic year
 * @returns {string} Complete copyright notice
 */
export const getCopyrightText = () => {
  const currentYear = getCurrentYear();
  return `QuailGame Footy © ${currentYear} QuailGame. All rights reserved.`;
};

/**
 * Generate simple footer copyright text with dynamic year
 * @returns {string} Simple copyright notice for footer
 */
export const getFooterCopyrightText = () => {
  const currentYear = getCurrentYear();
  return `© ${currentYear} QuailGame. All rights reserved.`;
};

/**
 * Get the description text for SEO metadata
 * @returns {string} Description for meta tags
 */
export const getCopyrightDescription = () => {
  return 'QuailGame is a league and team management platform.';
};

/**
 * Get the complete copyright and description for metadata
 * @returns {string} Combined copyright and description
 */
export const getFullCopyrightMeta = () => {
  return `${getCopyrightText()} ${getCopyrightDescription()}`;
};

/**
 * Get structured copyright data for various uses
 * @returns {object} Object containing copyright information
 */
export const getCopyrightData = () => {
  const currentYear = getCurrentYear();
  return {
    year: currentYear,
    company: 'QuailGame',
    product: 'QuailGame Footy',
    fullText: getCopyrightText(),
    description: getCopyrightDescription(),
    metaDescription: getFullCopyrightMeta()
  };
};